import React from 'react';
import PropTypes from 'prop-types';
import { auth } from "firebase";
import WithAuthLoader from './withAuthLoader';

const withAuth = (Component) => {
  class WithAuth extends Component {
    constructor() {
      super();

      this.state = {
        authUser: null,
        userId: null,
        isLoading: true
      };
    }

    getChildContext() {
      return {
        authUser: this.state.authUser,
        userId: this.state.userId,
        isLoading: this.state.isLoading
      };
    }

    async componentDidMount() {
      await auth().onAuthStateChanged(currentUser => {
        if (currentUser && currentUser.uid) {
          this.setState({ isLoading: false, authUser: currentUser, userId: currentUser.uid });
        } else {
          this.setState({ isLoading: false, authUser: currentUser, userId: null });
        }
      });
    }

    render() {
      return (
        this.state.isLoading
          ? <WithAuthLoader />
          : < Component />
      )
    }
  }

  WithAuth.childContextTypes = {
    authUser: PropTypes.object,
    userId: PropTypes.string,
    isLoading: PropTypes.bool,
  };

  return WithAuth;
}

export default withAuth;